module.exports = {"130433100":"馆陶镇","130433101":"房寨镇","130433102":"柴堡镇","130433103":"魏僧寨镇","130433200":"寿山寺乡","130433201":"王桥乡","130433202":"南徐村乡","130433203":"路桥乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130433.json
// module id = 114
// module chunks = 0